export const STRIKZA_TIME_ZONE = "Africa/Accra";

export function calendarDateInAccra(
  value: string | number | Date,
): string | null {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: STRIKZA_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const read = (type: Intl.DateTimeFormatPartTypes): string | undefined =>
    parts.find((part) => part.type === type)?.value;
  const year = read("year");
  const month = read("month");
  const day = read("day");
  return year && month && day ? `${year}-${month}-${day}` : null;
}

export function isKickoffOnSessionDate(
  kickoffAt: string | null | undefined,
  sessionDate: string,
): boolean {
  return typeof kickoffAt === "string" &&
    calendarDateInAccra(kickoffAt) === sessionDate;
}

export function dayOfYearInAccra(
  value: string | number | Date = new Date(),
): number | null {
  const sessionDate = calendarDateInAccra(value);
  if (!sessionDate) return null;
  const values = sessionDate.split("-").map(Number);
  if (values.length !== 3) return null;
  const [year, month, day] = values as [number, number, number];
  const start = Date.UTC(year, 0, 1);
  const current = Date.UTC(year, month - 1, day);
  return Math.floor((current - start) / 86_400_000) + 1;
}
